import React from 'react';
import { getShippingProviderLogo } from 'shipping/utils';

import { currentLanguage } from 'helpers/utils';
import { Button } from 'ui';

type Props = {
  transport: BackendPublic.Transport;
};

function TransportDetail({ transport }: Props) {
  const shippingProviderLogo = getShippingProviderLogo(transport.shipping_provider);

  return (
    <div className="flex flex-wrap items-center justify-between gap-4">
      <div className="flex items-center gap-4">
        {shippingProviderLogo && (
          <div>
            <img src={shippingProviderLogo} alt="shipping-provider-logo" className="h-10" />
          </div>
        )}
        <div>
          <div className="font-medium">{currentLanguage(transport.shipping_type_name)}</div>
          <div className="text-xs text-gray-500">{transport.status_name}</div>
        </div>
      </div>
      <div className="inline-flex flex-wrap gap-4">
        {transport.file.file && (
          <a href={transport.file.file} target="_blank" rel="noopener noreferrer">
            <Button>{gettext('Download shipping label')}</Button>
          </a>
        )}
        {transport.tracking_url && (
          <a href={transport.tracking_url} target="_blank" rel="noopener noreferrer">
            <Button>{gettext('Package tracking')}</Button>
          </a>
        )}
      </div>
    </div>
  );
}

export default TransportDetail;
